import { Form } from "antd";
import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  addWhatsappGroup,
  getWhatsappGroupById,
  updateWhatsappGroup,
} from "../../api/WhatsappGroupApi";
import { WhatsappGroupForm } from "./WhatsappGroupForm";
import AdnMessageSuccess from "../common/adnMessage/AdnMessageSuccess";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import { appTitle } from "../common/GeneralConfigurations";
import { AppRoutes } from "../../AppRoutes";

export const ManageWhatsappGroupPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [initValues, setInitValues] = useState({
    name: "",
    note: "",
    noteEN: "",
    link: "",
  });
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [form] = Form.useForm();
  const title =
    id !== undefined
      ? t("whatsappGroup.manage.titles.editWhatsappGroup")
      : t("whatsappGroup.manage.titles.newWhatsappGroup");

  useEffect(() => {
    document.title = `${appTitle} - ${title}`;
  }, [title]);

  const handleCancel = () => {
    navigate(AppRoutes.whatsappGroupList.path);
  };

  const getWhatsappGroupData = useCallback(async () => {
    try {
      const res = await getWhatsappGroupById(id);
      let name = res.data["name"].replace("#ADN4", "");
      let link = res.data["link"].replace("https://chat.whatsapp.com/", "");

      setInitValues({
        name: name,
        note: res.data["note"],
        noteEN: res.data["noteEN"],
        link: link,
      });
      setLoading(false);
    } catch (e) {
      navigate(AppRoutes.whatsappGroupList.path);
      AdnMessageError();
    }
  }, [id, navigate]);

  useEffect(() => {
    if (id !== undefined) getWhatsappGroupData();
    else setLoading(false);
  }, [id, getWhatsappGroupData]);

  useEffect(() => form.resetFields(), [initValues, form]);

  const add = async (whatsappgroup) => {
    setSubmitLoading(true);
    whatsappgroup.name = "#ADN4" + whatsappgroup.name;
    whatsappgroup.link = "https://chat.whatsapp.com/" + whatsappgroup.link;
    const res = await addWhatsappGroup(whatsappgroup);
    if (res.status === 201) {
      navigate(AppRoutes.whatsappGroupList.path);
      AdnMessageSuccess();
    } else {
      setSubmitLoading(false);
      AdnMessageError();
    }
  };

  const update = async (whatsappgroup) => {
    setSubmitLoading(true);
    whatsappgroup.id = id;
    whatsappgroup.name = "#ADN4" + whatsappgroup.name;
    whatsappgroup.link = "https://chat.whatsapp.com/" + whatsappgroup.link;
    const res = await updateWhatsappGroup(whatsappgroup);
    if (res.status === 200) {
      navigate(AppRoutes.whatsappGroupList.path);
      AdnMessageSuccess();
    } else {
      setSubmitLoading(false);
      AdnMessageError();
    }
  };

  return (
    <WhatsappGroupForm
      form={form}
      initValues={initValues}
      title={title}
      handleFinish={(values) =>
        id === undefined ? add(values) : update(values)
      }
      handleCancel={handleCancel}
      loading={loading}
      submitLoading={submitLoading}
    />
  );
};
